import { FormInstance } from 'antd';
import { useCallback } from 'react';
import { ImmerHook } from 'use-immer';
import useToggle from './useToggle';

export interface UseControlModalResult {
  openModal: boolean;
  setCloseModal: (form?: FormInstance) => void;
  setOpenAddModal: () => void;
  setOpenEditModal: (data: any) => void;
}

const useControlModal = (
  setEditItem: ImmerHook<any>[1],
  setStateAction: (action: 'create' | 'edit') => void
): UseControlModalResult => {
  const { value: openModal, setFalse, setTrue: setOpen } = useToggle(false);

  const setCloseModal = useCallback(
    (form?: Parameters<UseControlModalResult['setCloseModal']>[0]) => {
      setEditItem({});
      setFalse();

      if (form) form?.resetFields();
    },
    [setFalse]
  );

  const setOpenAddModal = useCallback(() => {
    setStateAction('create');
    setEditItem({});
    setOpen();
  }, [setOpen]);

  const setOpenEditModal = useCallback((data) => {
    setStateAction('edit');
    setEditItem(data);
    setOpen();
  }, []);

  return {
    openModal,
    setCloseModal,
    setOpenAddModal,
    setOpenEditModal,
  };
};

export default useControlModal;
